export const routes = {
  login: '/',
  emailLogin: '/email',
  googleLogin: '/authenticate/google',
  passwordlessAuth: '/passwordless-auth',
  promoCode: '/promo-code',
};
